import { axiosInstance } from '../axios';
import type { PaginatedResponse, ApiResponse } from '../../types/common';
import type {
  InstituteListDto,
  InstituteDetailDto,
  SystemConfigurationDto,
} from '../../types/institute';

export interface GetInstitutesParams {
  pageNumber?: number;
  pageSize?: number;
  isActive?: boolean;
  search?: string;
}

export const institutesApi = {
  getList: (params: GetInstitutesParams) =>
    axiosInstance.get<PaginatedResponse<InstituteListDto>>('/v1/product-admin/institutes', { params }),

  getDetail: (id: number) =>
    axiosInstance.get<ApiResponse<InstituteDetailDto>>(`/v1/product-admin/institutes/${id}`),

  activate: (id: number, activate: boolean, deactivationReason?: string) =>
    axiosInstance.patch<ApiResponse<void>>(`/v1/product-admin/institutes/${id}/activate`, {
      activate,
      deactivationReason,
    }),

  getFeatureFlags: (id: number) =>
    axiosInstance.get<ApiResponse<Record<string, boolean>>>(`/v1/product-admin/institutes/${id}/feature-flags`),

  setFeatureFlag: (id: number, featureKey: string, isEnabled: boolean) =>
    axiosInstance.patch<ApiResponse<void>>(`/v1/product-admin/institutes/${id}/feature-flags/${featureKey}`, { isEnabled }),

  getSystemConfigs: () =>
    axiosInstance.get<ApiResponse<SystemConfigurationDto[]>>('/v1/product-admin/system-configurations'),

  updateSystemConfig: (key: string, value: string) =>
    axiosInstance.patch<ApiResponse<void>>(`/v1/product-admin/system-configurations/${key}`, {
      value,
    }),
};
